import { Modal } from '@overdose/components'
import classNames from 'classnames'
import styles from './Dialogue.module.css'
import { DialogueProps } from './Dialogue.types'

export const Dialogue = ({
  cancelText,
  children,
  okText,
  visible,
  onOk,
  onCancel,
  size = 'md',
  wrapperClassName,
  modalClass,
  simple = false,
}: DialogueProps) => {
  return (
    <Modal
      simple={simple}
      theme={{
        root: classNames(
          styles.root,
          wrapperClassName,
          'grid md:grid-cols-12 md:!px-20 !items-start pt-32'
        ),
        mask: styles.mask,
        close_button: styles.closeBtn,
        modal: classNames('col-span-full w-[90%]', modalClass, {
          'xl:col-span-4 md:col-span-6 xl:col-start-5 md:col-start-2 lg:col-start-4':
            size === 'md',
          'lg:col-span-4 lg:mx-6 xl:col-start-5 md:col-span-6 md:col-start-2 lg:col-start-4':
            size === 'sm',
        }),
      }}
      hideFooter
      visible={visible}
      okText={okText}
      cancelText={cancelText}
      onOk={() => {
        return onOk()
      }}
      onCancel={() => {
        return onCancel()
      }}>
      {children}
    </Modal>
  )
}
